module.exports = __webpack_public_path__ + "static/media/bd.1a0790a1.jpg";